const SiNoOptions = [
  {
    label: "Selecciona",
    value: '',
  },
  {
  label: "Si",
  value: "Si",
  },
  {
  label: "No",
  value: "No",
  }
];

export default SiNoOptions;